import { Resolver, Mutation, Arg, Ctx, Directive } from 'type-graphql'
import { In } from 'typeorm'

import { ScalarObject } from '@things-factory/shell'

import { PagePreference } from './page-preference'
import { NewPagePreference, PagePreferencePatch } from './page-preference-type'

@Resolver(PagePreference)
export class PagePreferenceMutation {
  @Directive('@transaction')
  @Mutation(returns => PagePreference, { description: 'To create my new PagePreference' })
  async createMyPagePreference(
    @Arg('pagePreference') pagePreference: NewPagePreference,
    @Ctx() context: ResolverContext
  ): Promise<PagePreference> {
    const { domain, user, tx } = context.state

    return await tx.getRepository(PagePreference).save({
      ...pagePreference,
      domain,
      creator: user,
      updater: user
    })
  }

  @Directive('@transaction')
  @Mutation(returns => PagePreference, { description: 'To create or update my PagePreference' })
  async updateMyPagePreference(
    @Arg('page') page: string,
    @Arg('element') element: string,
    @Arg('preference', type => ScalarObject) preference: { [key: string]: any },
    @Ctx() context: any
  ): Promise<PagePreference> {
    const { domain, user, tx } = context.state

    if (!page || !element) {
      throw 'page and element are required.'
    }

    const pagePreference = await tx.getRepository(PagePreference).findOne({
      where: { domain: { id: domain.id }, user: { id: user.id }, page, element }
    })

    return await tx.getRepository(PagePreference).save({
      ...pagePreference,
      domain,
      user,
      page,
      element,
      preference,
      creator: user,
      updater: user
    })
  }

  @Directive('@transaction')
  @Mutation(returns => Boolean, { description: 'To delete my PagePreference' })
  async deleteMyPagePreference(
    @Arg('page') page: string,
    @Arg('element') element: string,
    @Ctx() context: ResolverContext
  ): Promise<boolean> {
    const { domain, user, tx } = context.state

    await tx.getRepository(PagePreference).delete({
      domain: { id: domain.id },
      user: { id: user.id },
      page,
      element
    })

    return true
  }

  @Directive('@transaction')
  @Mutation(returns => Boolean, { description: 'To delete PagePreference' })
  async deletePagePreference(@Arg('id') id: string, @Ctx() context: ResolverContext): Promise<boolean> {
    const { domain, tx } = context.state

    await tx.getRepository(PagePreference).delete({ domain: { id: domain.id }, id })

    return true
  }

  @Directive('@transaction')
  @Mutation(returns => Boolean, { description: 'To delete multiple PagePreferences' })
  async deletePagePreferences(
    @Arg('ids', type => [String]) ids: string[],
    @Ctx() context: ResolverContext
  ): Promise<boolean> {
    const { domain, tx } = context.state

    await tx.getRepository(PagePreference).delete({
      domain: { id: domain.id },
      id: In(ids)
    })

    return true
  }
}
